import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* About Section */}
        <div className="footer-section">
          <h3>About Us</h3>
          <p>
            We are Home Appliance Service Madurai, offering expert repair services for various home appliances like washing machines, fridges, ACs, and more. Our team is dedicated to providing reliable, quick, and affordable solutions to meet your appliance repair needs.
          </p>
        </div>

        {/* Quick Services Section */}
        <div className="footer-section">
          <h3>Quick Services</h3>
          <ul>
            <Link to='/washing-machine-service' ><li>Washing Machine Repair</li></Link>
           <Link to='/ac-service'> <li>AC Repair & Service</li></Link>
           <Link to='/fridge-service'><li>Fridge Repair</li></Link>
           <Link to='/tv-service'><li>Tv Service</li></Link>
           <Link to='/microwave-oven-service'><li>Microwave Oven Service</li></Link>
           <Link to='/water-heater-service'><li>Water Heater Service</li></Link>
           <Link to='/water-purifier-service'><li>Water Purifier Service</li></Link>
          </ul>
        </div>

        {/* Privacy Policy & Terms & Conditions Section */}
        <div className="footer-section">
          <h3>Links</h3>
          <ul>
            <Link to='/privacy-policy'><li>Privacy Policy</li></Link>
            <Link to='/terms-conditions'><li>Terms & Conditions</li></Link>
          </ul>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Home Appliance Service Madurai. All rights reserved.</p>
      </div>
    </footer>
  );
}
